import { useState } from "react";
import { useForm } from "react-hook-form";
import { Spinner } from "reactstrap";
import landinlogo from "assets/images/logo-Landin.svg";
import { ReactComponent as MessageIcon } from "../../assets/images/Message.svg";
import { registerOptions } from "./common/utility";
import ShowError, { ShowSuccess } from "./common/ShowError";
import Input from "./common/Input";
import {
  Wrapper,
  Head,
  Titles,
  TitleTexts,
  Content,
  NextButton,
  ChangePage,
} from "./LoginStyles.jsx";
import { useMutation } from "react-query";
import { submitResetPassword } from "api/user/resetpassword";

const ResetPassword = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [signupErrors, setSignupErrors] = useState();

  const { register, handleSubmit, errors, formState, getValues } = useForm({
    mode: "onTouched",
  });
  const { touched } = formState;

  const confirmText =
    "ایمیل خود را چک کنید و بعد از تایید، پسورد جدید را وارد کنید";

  const resetReq = useMutation(
    email => submitResetPassword({ email_address: email }),
    {
      onSuccess: () => {
        setSignupErrors();
        setShowSuccess(true);
      },
      onError: err => {
        try {
          if (err.response.data.body) {
            setSignupErrors(err.response.data.body.errors);
          } else {
            setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
          }
        } catch (err) {
          setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
        }
      },
    }
  );

  const handleReset = () => {
    resetReq.mutate(getValues("email"));
  };

  return (
    <Wrapper>
      <Head style={{ marginBottom: 40 }}>
        <Titles>
          <TitleTexts>
            <div className="main-text">فراموشی رمز</div>
          </TitleTexts>
          <a href="https://landin.ir">
            <img src={landinlogo} alt="لوگو" />
          </a>
        </Titles>
      </Head>
      <Content style={{ minHeight: 185 }}>
        <ChangePage style={{ marginBottom: 10, justifyContent: "flex-start" }}>
          <div className="light-text" style={{ fontWeight: 300 }}>
            جهت ارسال لینک فراموشی رمز عبور، ایمیل خود را وارد کنید
          </div>
        </ChangePage>
        <Input
          ref={register(registerOptions.email)}
          name="email"
          isFine={touched.email && !errors.email}
          isError={errors.email}
          Icon={<MessageIcon />}
          placeholder="ایمیل"
        />
        {errors.email && <ShowError message={errors.email.message} />}
        {signupErrors &&
          signupErrors.map(e => (
            <ShowError key={e.message} message={e.message} />
          ))}
        {showSuccess && <ShowSuccess message={confirmText} />}
        <NextButton
          onClick={handleSubmit(handleReset)}
          style={{ marginBottom: 15 }}
        >
          ارسال لینک
          {resetReq.isLoading && (
            <Spinner size="sm" style={{ color: "white" }} />
          )}
        </NextButton>
        <ChangePage>
          <div className="light-text">هنوز عضو نشده‌اید؟</div>
          <a href="/signup">
            <div className="link-text">ثبت نام کنید</div>
          </a>
        </ChangePage>
      </Content>
    </Wrapper>
  );
};

export default ResetPassword;
